import {
  IAgoraRTCTokenResponse,
  IAgoraRTMTokenResponse,
  IAppointmentStatusResponse,
  ICancelScheduleAppointmentsRequest,
  ICancelScheduleAppointmentsResponse,
  IDoctorScheduleSlots,
  IPushCallNotificationPayload,
  IPushCallNotificationResponse,
  IRescheduleAppointmentRequest,
  IRescheduleAppointmentResponse,
  IScheduleListing,
  ISearchedAppointmentResponse,
  ISendOtpPatientCreationRequest,
  ISendOtpPatientCreationResponse,
} from "@/models/ApiRequestResponse/doctor";
import {
  IScheduleAppointmentDateRangeParams,
  IScheduleSlotsRequest,
} from "@/models/doctor";
import { GBSCError } from "@/models/GBSCError";

import { deleteMethod, get, post } from "@/utils/TypedApi";

import {
  APIEndpoint,
  IAPIStatusCode,
  IAPIStatusType,
  messages,
} from "@/utils/apis/APIEndpointConfig";

export const getScheduleAppointmentListingApi = async (
  params: IScheduleAppointmentDateRangeParams
): Promise<IScheduleListing | GBSCError> => {
  try {
    let url = APIEndpoint.doctor.scheduleList;
    if (params.start && params.end) {
      const { start, end } = params;
      url += `?start=${start}&end=${end}`;
    }
    const response = await get<IScheduleListing>(url);
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const getDoctorScheduleSlotApi = async ({
  doctorId,
  clinicId,
}: IScheduleSlotsRequest): Promise<IDoctorScheduleSlots | GBSCError> => {
  try {
    let url = APIEndpoint.doctor.scheduleSlots;
    url += doctorId ? `/${doctorId}` : "";
    url += clinicId ? `?clinicId=${clinicId}` : "";
    const response = await get<IDoctorScheduleSlots>(url);
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const sendOtpPatientCreationApi = async (
  requestBody: ISendOtpPatientCreationRequest
): Promise<ISendOtpPatientCreationResponse | GBSCError> => {
  try {
    const response = await post<ISendOtpPatientCreationResponse>(
      APIEndpoint.doctor.sendOtpPatientCreation,
      requestBody
    );
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const cancelScheduleAppointmentsApi = async (
  requestBody: ICancelScheduleAppointmentsRequest
): Promise<ICancelScheduleAppointmentsResponse | GBSCError> => {
  try {
    const response = await deleteMethod<ICancelScheduleAppointmentsResponse>(
      APIEndpoint.doctor.cancelScheduleAppointment,
      requestBody
    );
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const rescheduleCancelledAppointmentsApi = async (
  requestBody: IRescheduleAppointmentRequest
): Promise<IRescheduleAppointmentResponse | GBSCError> => {
  try {
    const response = await post<IRescheduleAppointmentResponse>(
      APIEndpoint.doctor.reschedule,
      requestBody
    );
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const searchAppointmentsApi = async (
  search: string,
  startDate?: string,
  endDate?: string
): Promise<ISearchedAppointmentResponse | GBSCError> => {
  try {
    let url = `${APIEndpoint.doctor.searchAppointments}?search=${search}`;
    url +=
      startDate && endDate ? `&startDate=${startDate}&endDate=${endDate}` : "";

    const response = await get<ISearchedAppointmentResponse>(url);
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const agoraRTCTokenApi = async (
  channelName: string
): Promise<IAgoraRTCTokenResponse | GBSCError> => {
  try {
    let url = `${APIEndpoint.doctor.agoraRTCToken}?channelName=${channelName}`;
    const response = await get<IAgoraRTCTokenResponse>(url);
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const agoraRTMTokenApi = async (
  channelName: string
): Promise<IAgoraRTMTokenResponse | GBSCError> => {
  try {
    let url = `${APIEndpoint.doctor.agoraRTMToken}?channelName=${channelName}`;
    const response = await get<IAgoraRTMTokenResponse>(url);
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const pushCallNotificationApi = async (
  requestBody: IPushCallNotificationPayload
): Promise<IPushCallNotificationResponse | GBSCError> => {
  try {
    const uuid = crypto.randomUUID();
    const response = await post<IPushCallNotificationResponse>(
      APIEndpoint.doctor.pushCallNotification,
      { ...requestBody, uuid }
    );
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const checkAppointmentStatusApi = async (
  bookingId: string,
  isDetailed = false
): Promise<IAppointmentStatusResponse | GBSCError> => {
  try {
    let url = `${APIEndpoint.doctor.checkAppointmentStatus}${bookingId}?detailed=${isDetailed}`;
    const response = await get<IAppointmentStatusResponse>(url);
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }
  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};
